export interface subtaskTypes  {
    subtask:string,
    count:number
}
export interface taskTypes  {
    task:string,
    count:number
}

interface Metadata {
    elementName: string;
    elementValue: string;
    isDeleted: boolean;
}

export interface titileInformation {
    id: string;
    title: string;
    current_task: string;
    current_subtask: string;
    status: string;
    type: string;
    element: string;
    assetCondition: string | null;
    physical_location_rack: string;
    physical_location_shelf: string;
    physical_location_vault: string;
    current_user: string;
    
    metadata: Metadata[];
}
export const titileInformationInitialState: titileInformation = {
    id: '',
    title: '',
    current_task: '',
    current_subtask: '',
    status: '',
    type: '',
    element: '',
    assetCondition: null,
    physical_location_rack: '',
    physical_location_shelf: '',
    physical_location_vault: '',
    current_user: '',
    metadata: [],
};

export interface taskDetails {
    id:string;
    title:string;
    taskName:string;
    subtaskName:string;
    taskId:string;
    subtaskId:string;
    taskData:any;
    parentId:string;
    metadata:any[]
}
export const taskDetailsInitial = {
    id:'',
    title:'',
    taskName:'',
    subtaskName:'',
    taskId:'',
    subtaskId:'',
    taskData:[],
    parentId:'',
    metadata:[]
}
export interface options {
    key:string,
    value:string,
    text:string
}
export const  optionsInitial = {
    key:'',
    value:'',
    text:''
}

export interface componentsProps {
    itemId: string,
    status: number,
    subTaskId: string,
    subTaskName: string,
    taskId: string,
    taskName: string,
    title: string
}

export interface NFAI_SmarttrackerProps { 
  taskName: string,
  subtaskName: string,
  filmTitle: string,
  reelName: string,
  empId: string,
  empName: string
}
export const NFAI_SmarttrackerPropsInitial =  { 
    taskName: '',
    subtaskName: '',
    filmTitle: '',
    reelName: '',
    empId: '',
    empName: ''
  }

  export interface dropdownDetailsProps {
    titleList: options[];
    selectedTitle: string;
    reelList: options[];
    selectedReel: string;
    empIdList:options[];
    selectedEmpId:string;
    empNameList:options[];
    selectedEmpName:string
  }

  export const formatKey = (key: string): string => {
    return key
      .toLowerCase()
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };


// export function getNextTaskId(tasks: any[], currentTaskId: any,currentSubTaskId:string) {
//     const currentTaskIndex = tasks.findIndex(task => task.taskId === currentTaskId);
//     if (currentTaskIndex !== -1 && currentTaskIndex + 1 < tasks.length) {
//       const nextTask = tasks[currentTaskIndex + 1];
//       const dependencyTaskTemp = (nextTask.dependencyTask === undefined  || nextTask.dependencyTask === null)? "" : nextTask.dependencyTask;
//       const totalSutask= tasks[currentTaskIndex]?.subTasks
//       const currentSubtask = tasks[currentTaskIndex]?.subTasks?.filter((subTask: { subTaskId: any; }) => subTask.subTaskId === currentSubTaskId);
//       if(nextTask.isParallel || dependencyTaskTemp !== '' || nextTask.status === 'Completed') {
//         return currentTaskId;
//       }
//       else if(totalSutask?.length > currentSubtask[0].subtaskIndex + 1){
//         if(totalSutask[currentSubtask[0].subtaskIndex + 1].subTaskstatus === 2){
//           return nextTask.taskId;
//         }else {
//           return currentTaskId;
//         }
//       }
//       else{
//         return nextTask.taskId;
//       }
//     }
//     return currentTaskId;
//   }
  
//   export function getNextSubTaskId(tasks: any[], currentTaskId: any, currentSubTaskId: any): any {
//     // Find the index of the current task in the tasks array
//     const currentTaskIndex = tasks.findIndex(task => task.taskId === currentTaskId);
 
//     // Check if the current task is found in the 'tasks' array
//     if (currentTaskIndex !== -1) {
//         // Find the index of the current subtask in the subTasks array of the current task
//         const currentSubTaskIndex = tasks[currentTaskIndex].subTasks.findIndex((subTask: { subTaskId: any; }) => subTask.subTaskId === currentSubTaskId);
 
//         // Check if the next subtask exists within the current task's subTasks array
//         if (currentSubTaskIndex !== -1 && currentSubTaskIndex + 1 < tasks[currentTaskIndex].subTasks.length && tasks[currentTaskIndex].subTasks[currentSubTaskIndex + 1].subTaskstatus !== 2) {
//             // Return the ID of the next subtask within the current task
//               return tasks[currentTaskIndex].subTasks[currentSubTaskIndex + 1].subTaskId;
//         }
//         // Check if there is a next task
//         if (currentTaskIndex + 1 < tasks.length) {
//             // Get the next task
//             const nextTask = tasks[currentTaskIndex + 1];
//             const dependencyTaskTemp = (nextTask.dependencyTask === undefined || nextTask.dependencyTask === null) ? "" : nextTask.dependencyTask;
//             // Check if the next task has subtasks
//             const nextSubTask = nextTask?.subTasks[0];
//             if(nextTask.subTasks.length > 0 &&(nextTask.status === 'Completed' || nextTask.isParallel || dependencyTaskTemp !== "")){
//                   return currentSubTaskId
//             }
//             else if(dependencyTaskTemp === '' && nextTask.status !== 'Completed'){
//                 if(nextSubTask.subTaskstatus == 2){
//                   return nextTask.subTasks[nextSubTask.subtaskIndex + 1].subtaskId
//                 }else{
//               return nextSubTask.subTaskId;
//               }
//             }
//             else{
              
//                 return nextSubTask.subTaskId;
//             }
//         }
//     }
 
//     // Return the current subtask ID as the next task ID if no next subtask is found
//     return currentSubTaskId;
// }
export function getNextTaskOrSubTaskId(tasks: any[], currentTaskId: any, currentSubTaskId: any): any {
  // Find the index of the current task in the tasks array
  const currentTaskIndex = tasks.findIndex(task => task.taskId === currentTaskId);

  // If the current task is found
  if (currentTaskIndex !== -1) {
      const currentTask = tasks[currentTaskIndex];
      const currentSubTaskIndex = currentTask.subTasks.findIndex((subTask: { subTaskId: any; }) => subTask.subTaskId === currentSubTaskId);

      // Check if there is a next subtask within the current task
      if (currentSubTaskIndex !== -1 && currentSubTaskIndex + 1 < currentTask.subTasks.length) {
          const nextSubTask = currentTask.subTasks[currentSubTaskIndex + 1];

          // If the next subtask is not completed, return its Subtask Id
          if (nextSubTask.subTaskstatus !== 2) {
              return {
                nextTaskId: currentTaskId,
                nextSubtaskId: nextSubTask.subTaskId,
                afterRejectSubtaskName: ''
              };
          }
      }
    const isFirstTaskParallel = tasks.find(e=> e.taskIndex === 0).taskName === currentTask.taskName;
    // Handle parallel tasks or first task
      if(currentTask.isParallel && !isFirstTaskParallel){
        return {    
          nextTaskId: currentTaskId,
            nextSubtaskId: currentSubTaskId,
            afterRejectSubtaskName: ''
        };
      }

      // Check if there is a next task
      for (let i = currentTaskIndex + 1; i < tasks.length; i++) {
          const nextTask = tasks[i];
          const hasSubTaskStatus2 = nextTask.subTasks.some((item:any) => item.subTaskstatus === 2);
          if(currentTask.taskName === 'Final Restoration' && nextTask.taskName === 'Color Grading' && hasSubTaskStatus2){
            return {
              nextTaskId: currentTaskId,
              nextSubtaskId: currentSubTaskId,
              afterRejectSubtaskName: currentTask.subTasks[currentSubTaskIndex].subTaskName || ''
            }
          }
          if (nextTask.status !== 'Completed' && (nextTask.dependencyTask === '' || isFirstTaskParallel)) {
              const firstUncompletedSubtask = nextTask.subTasks.find((subTask: { subTaskstatus: any; }) => subTask.subTaskstatus !== 2);
              // If found an uncompleted subtask in the next task, return its ID
              if (firstUncompletedSubtask) {
                  return {
                      nextTaskId:nextTask.taskId,
                      nextSubtaskId: firstUncompletedSubtask.subTaskId,
                      afterRejectSubtaskName: ''
                  };
              }
          }
      }
  }
  // If no next task or subtask is found, return the current task and subtask IDs
  return {
      nextTaskId: currentTaskId,
      nextSubtaskId: currentSubTaskId,
      afterRejectSubtaskName: ''
  };
}

export const roleBasedCardHiddenForTask = (role:string):string[] =>{
 return role === 'Operator' ? ['Full Restoration'] : ['Full Restoration', 'Cutlist Quality Check'];
}
export const roleBasedCardHiddenForsubtask = (selectedTask: string) => {
    if (!selectedTask) return '';
    
    return selectedTask === 'Full Restoration'
      ? ['Restoration', 'Self QC']
      : ['Quality Check'];
  };

export const filteredUser = (value:any) =>{

}
  
export type ElementIdListTypes = {
    AssetId: string;
    InputFormat: string;
    DeliveryFormat: string;
    FilmElement: string;
    FilmType: string;
    FilmGauge: string; // Fixed typo here
  };  



  export interface CutlistStatusTypes {
    employee_ID: string;
    employee_Name: string;
    project_Name: string;
    reel_No: string;
    shot_No: string;
    start_Frame: string;
    end_Frame: string;
    total_Frame: string;
    cutlist_Status: string;
    status: string;
    current_owner: string;
  }
  
  export const CutlistStatusInitial  = {
    employee_ID: '',
    employee_Name: '',
    project_Name: '',
    reel_No: '',
    shot_No: '',
    start_Frame: '',
    end_Frame: '',
    total_Frame: '',
    cutlist_Status: '',
    status: '',
    current_owner: ''
  }

export  interface QcProps {
    id: string,
    date: string,
    reportTime: string,
    projectName: string,
    team: string,
    operatorId: string,
    operatorName: string,
    q_EmpId: string,
    q_EmpName: string,
    process: string,
    resolution: string,
    reel: string,
    shot: string,
    startFrame: number,
    endFrame: number,
    totalFrame: number,
    appFrames: number,
    rejFrames: number,
    status: string,
  }

export const initialQcProps: QcProps = {
  id: "",
  date: "",
  reportTime: "",
  projectName: "",
  team: "",
  operatorId: "",
  operatorName: "",
  q_EmpId: "",
  q_EmpName: "",
  process: "",
  resolution: "",
  reel: "",
  shot: "",
  startFrame: 0,
  endFrame: 0,
  totalFrame: 0,
  appFrames: 0,
  rejFrames: 0,
  status: "",
};

